import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './index.css';
import App from './App';
import Success from './pages/success';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Routes>
    <Route path= '/' element={<App />} />
    <Route path= '/success' element={<Success />} />
  </Routes>
  </BrowserRouter>
);


